var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-fluid" }, [
    _c("div", { staticClass: "function-card" }, [
      _c(
        "button",
        {
          staticClass: "btn btn-primary",
          staticStyle: { "margin-top": "30px", "margin-right": "10px" },
          attrs: {
            type: "button",
            "data-toggle": "modal",
            "data-target": "#factoryModal",
          },
          on: {
            click: function ($event) {
              return _vm.factoryModal({ action: "add" })
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Add")) + " ")]
      ),
    ]),
    _c(
      "div",
      { staticClass: "yahome-table-wrap" },
      [
        _c(
          "VueBootstrap4Table",
          {
            attrs: {
              rows: _vm.rows,
              columns: _vm.columns,
              config: _vm.config,
              "total-rows": _vm.totalData,
            },
            on: { "on-change-query": _vm.changePage },
            scopedSlots: _vm._u([
              {
                key: "IsSupervisor",
                fn: function (props) {
                  return [
                    props.cell_value
                      ? _c("span", [_vm._v("是")])
                      : _c("span", [_vm._v("否")]),
                  ]
                },
              },
              {
                key: "IsEnabled",
                fn: function (props) {
                  return [
                    props.cell_value
                      ? _c("eva-icon", {
                          attrs: { fill: "#000", name: "checkmark-outline" },
                        })
                      : _c("eva-icon", {
                          attrs: { fill: "#000", name: "close-outline" },
                        }),
                  ]
                },
              },
              {
                key: "Edit",
                fn: function (props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-info btn-sm",
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#factoryModal",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.factoryModal({
                              action: "edit",
                              data: props.row,
                            })
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Edit")) + " ")]
                    ),
                  ]
                },
              },
              {
                key: "Delete",
                fn: function (props) {
                  return [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-danger btn-sm",
                        attrs: {
                          type: "button",
                          "data-toggle": "modal",
                          "data-target": "#delFactoryModal",
                        },
                        on: {
                          click: function ($event) {
                            _vm.factory = { ...props.row }
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
                    ),
                  ]
                },
              },
            ]),
          },
          [_c("template", { slot: "empty-results" }, [_vm._v(" 暫無資料 ")])],
          2
        ),
      ],
      1
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "factoryModal",
          tabindex: "-1",
          "data-backdrop": "static",
        },
      },
      [
        _c(
          "div",
          { staticClass: "modal-dialog modal-dialog-centered" },
          [
            _c("ValidationObserver", {
              ref: "factory",
              staticClass: "modal-content",
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function ({ handleSubmit, reset }) {
                    return [
                      _c(
                        "form",
                        {
                          on: {
                            reset: function ($event) {
                              $event.preventDefault()
                              return reset.apply(null, arguments)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "modal-header" }, [
                            _vm.action === "add"
                              ? _c("span", [_vm._v("新增廠別")])
                              : _c("span", [_vm._v("編輯廠別")]),
                          ]),
                          _c("div", { staticClass: "modal-body" }, [
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { name: "廠別", rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for: "modal-factory-name",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _vm._v(" 廠別 "),
                                              ]
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.trim",
                                                  value: _vm.factory.Name,
                                                  expression: "factory.Name",
                                                  modifiers: { trim: true },
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                id: "modal-factory-name",
                                                maxlength: "200",
                                              },
                                              domProps: {
                                                value: _vm.factory.Name,
                                              },
                                              on: {
                                                compositionstart: function (
                                                  $event
                                                ) {
                                                  _vm.is_composing = true
                                                },
                                                compositionend: function (
                                                  $event
                                                ) {
                                                  _vm.is_composing = false
                                                },
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.factory,
                                                    "Name",
                                                    $event.target.value.trim()
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            errors[0] && !_vm.is_composing
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                            _c(
                              "div",
                              { staticClass: "form-group" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { name: "代碼", rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "label",
                                              {
                                                attrs: {
                                                  for: "modal-factory-code",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _vm._v(" 代碼 "),
                                              ]
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model.trim",
                                                  value: _vm.factory.Code,
                                                  expression: "factory.Code",
                                                  modifiers: { trim: true },
                                                },
                                              ],
                                              staticClass: "form-control",
                                              attrs: {
                                                type: "text",
                                                id: "modal-factory-code",
                                                maxlength: "200",
                                              },
                                              domProps: {
                                                value: _vm.factory.Code,
                                              },
                                              on: {
                                                input: function ($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.$set(
                                                    _vm.factory,
                                                    "Code",
                                                    $event.target.value.trim()
                                                  )
                                                },
                                                blur: function ($event) {
                                                  return _vm.$forceUpdate()
                                                },
                                              },
                                            }),
                                            errors[0] && !_vm.is_composing
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]),
                          _c("div", { staticClass: "modal-footer" }, [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-secondary",
                                attrs: {
                                  type: "reset",
                                  "data-dismiss": "modal",
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Buttons.Cancel")) + " "
                                ),
                              ]
                            ),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-success",
                                attrs: { type: "button" },
                                on: {
                                  click: function ($event) {
                                    return handleSubmit(_vm.saveFactory)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.i18n("Buttons.Save")) + " "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ]
    ),
    _c(
      "div",
      {
        staticClass: "modal fade",
        attrs: {
          id: "delFactoryModal",
          tabindex: "-1",
          "data-backdrop": "static",
        },
      },
      [
        _c("div", { staticClass: "modal-dialog modal-dialog-centered" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [_vm._v("刪除廠別")]),
            _c("div", { staticClass: "modal-body" }, [
              _vm._v(" 確認刪除 "),
              _c(
                "span",
                { staticStyle: { "font-weight": "bolder", color: "red" } },
                [_vm._v(" " + _vm._s(_vm.factory.Name) + " ")]
              ),
              _vm._v(" ? "),
            ]),
            _c("div", { staticClass: "modal-footer" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  attrs: { type: "reset", "data-dismiss": "modal" },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Cancel")) + " ")]
              ),
              _c(
                "button",
                {
                  staticClass: "btn btn-danger",
                  attrs: { type: "button", "data-dismiss": "modal" },
                  on: { click: _vm.delFactory },
                },
                [_vm._v(" " + _vm._s(_vm.i18n("Buttons.Delete")) + " ")]
              ),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }